import React from 'react'
import styled from 'styled-components/macro'

import SEO from '../components/organisms/SEO'

export default function CenteredLayout({
  HeaderComp,
  FooterComp,
  CtaComp,
  children,
  style,
}) {
  return (
    <>
      <SEO />
      {HeaderComp}
      <MainContent>
        <ContentWrapper style={style}>{children}</ContentWrapper>
        {CtaComp}
      </MainContent>
      {FooterComp}
    </>
  )
}

const MainContent = styled.main`
  grid-area: sidebar;
  grid-column: span 2;
`

const ContentWrapper = styled.div`
  width: 100%;
  max-width: 1160px;
  padding: 40px 20px;
  margin: 0 auto;
`
